import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import boximg1 from '../assets/img/iot-b73889b5.webp';
import boximg2 from '../assets/img/sss.webp';
import boximg3 from '../assets/img/sai.webp';
import boximg4 from '../assets/img/td-deep-learning.webp';
import boximg5 from '../assets/img/robot.jpg';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ArrowRightCircle } from 'react-bootstrap-icons';

import img1 from '../assets/img/bigdata.png';
import img2 from '../assets/img/chip.png';
import img3 from '../assets/img/python.png';
import img4 from '../assets/img/r-logo-svg.png';
import img5 from '../assets/img/data.png';
import img6 from '../assets/img/nlp.png';



const Services=()=>{
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
    };
    const cardInfo=[
        {
            image:boximg1,
            title:"IoT and Systems",
            text:"Automotive, Network, high-speed interconnect protocols and Artificial/Visual computing applications.",
        },
        {
            image:boximg2,
            title:"Semiconductors",
            text:"Experience and expertise in IoT has helped build compelling solutions targeted for industrial, smart-city, smart-office and other control applications.",
        },
        {
            image:boximg3,
            title:"AI/ML Services",
            text:"Automotive, Network, high-speed interconnect protocols and Artificial/Visual computing applications.",
        },
        {
            image:boximg4,
            title:"Deep Learning",
            text:"Deep Learning is a subset of Machine Learning. It enables processing of data and creating predictions using neural networks.",
        },
        {
            image:boximg5,
            title:"Robotics",
            text:"Robots are widely used in such industries as automobile manufacture to perform simple repetitive tasks, and in industries where work must be performed in environments hazardous to humans.",
        }
    ];

    const renderCard=(card,index)=>{
        return(       
            <Card className='servicecard' key={index}>
                <div className='img-hover-zoom img-hover-zoom--colorize'>
                    <Card.Img variant="top" src={card.image} className='card-img '/>
                </div>
                <Card.Body className='text-body'>
                    <Card.Title className='text-body-hdng'>{card.title}</Card.Title>
                    <Card.Text className='text-body-para'>
                        {card.text}
                    </Card.Text>
                    <Button className='btn-readmore'>Connect Us</Button>
                </Card.Body>
            </Card>               
        );
    };

    return(
       <section className='services' id='services'>
            <Container>
                <h1 className='servhdng prod-hdng'>Our Services</h1>
                <p className='servheadpara prod-para'>Over the years Autoverse have gained significant knowledge and work experience in areas like Power Management, Automotive, Network  high-speed interconnect protocols and Artificial/Visual computing applications.</p>
                <Carousel responsive={responsive} infinite={true} autoPlaySpeed={1000} 
                autoPlay={false} swipeable={false} draggable={true} showDots={true} 
                removeArrowOnDeviceType={["tablet", "mobile","Desktop"]} className='service-slider'>
                    {cardInfo.map(renderCard)}
                </Carousel>
            </Container>
        </section>
    )
}

export default Services